export default [{
  label: 'Any'
}, {
  value: ['under-200', '250-499', '500-999'],
  keys: ['Under$200', '$250-$499', '$500-$999'],
  label: 'Under $999'
}, {
  value: '1000-1499',
  keys: ['$1000-$1499'],
  label: '$1,000-$1,499'
}, {
  value: '1500-1999',
  keys: ['$1500-$1999'],
  label: '$1,500-$1,999'
}, {
  value: ['2000-2499', '2500-2999'],
  keys: ['$2000-$2499', '$2500-$2999'],
  label: '$2,000-$2,999'
}, {
  value: ['3000-3999', '4000-4999'],
  keys: ['$3000-$3999', '$4000-$4999'],
  label: '$3,000-$4,999'
}, {
  value: ['5000-5999', '6000-6999', '7000-7999', '8000-8999', '9000-9999', '10000'],
  keys: ['$5000-$5999', '$6000-$6999', '$7000-$7999', '$8000-$8999', '$9000-$9999', '$10,000+'],
  label: '$5,000+'
}];